<script>
import { Base64 } from 'js-base64'
import { normalizeKeys } from 'base/config'
import { getScreenSize } from 'common/js/dom'
import { sexToString } from 'common/js/common'
import {
  formatCalculateData,
  formatTenThousand,
  formatLongStr,
  formatDisplayData
} from 'common/js/format'
import { groupColor } from './config'
import { getRelation, baoeShowWords, showImageViewer } from './common'
import { tempToFill } from 'components/liability/common'

export default {
  name: 'MindMapping',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    resultData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: true,
      mapData: {}
    }
  },
  watch: {
    resultData: {
      handler (value) {
        let mindData, insuranceTitle
        if (this.multiple) {
          const mindFm = this.buildMindFmData(value.members)
          const fmTotalbaof = mindFm.reduce((previous, current) => {
            return (previous += current.totalBaof)
          }, 0)
          insuranceTitle = value.name
          if (/的家庭保障计划/.test(insuranceTitle)) {
            insuranceTitle = insuranceTitle.replace(
              /的家庭保障计划/,
              '一家的<br>家庭保障计划'
            )
          }
          mindData = {
            content: `${(insuranceTitle || '').replace(/(.{8,8})/g, "$1<br/>")}<br>首年总保费<br><span>${fmTotalbaof}元</span>`,
            children: mindFm
          }
        } else {
          mindData = this.buildMindPbData(value)
        }
        mindData && (this.mapData = mindData)
      },
      immediate: true
    }
  },
  mounted () {
    this.screenSize = getScreenSize()
    appBridge.showLoading()
    this.renderMind()
  },
  methods: {
    buildMindPbData (preData) {
      const { resultData, liabilities } = preData
      if (!resultData || !liabilities) return
      function getAPerson (key) {
        return resultData.personData.personOrderList.find(
          item => item.key === key
        )
      }
      function buildMapInfo (productList, liabilities, insuranceData) {
        return productList.reduce((accumulate, current, index) => {
          const { totalBaof, titleName, mulInsOrderList } = current
          const liab = liabilities[index]
          const main = mulInsOrderList[0]
          const name = formatLongStr(titleName, 10)
          let baoe = baoeShowWords(main)
          baoe = typeof baoe === 'string' ? formatLongStr(baoe, 4) : baoe
          const content = `${name}<br>保额：${baoe}，${
            main.iDurationDesc
          }<br>保费：${formatTenThousand(totalBaof)}元，${main.pPeriodDesc}`
          let liability = []
          if (liab) {
            const descLiabilities = getLiabilitiesComponents(
              liab,
              insuranceData
            )
            liability = descLiabilities
              ? descLiabilities.reduce((prev, cur) => {
                if (!cur) return prev
                return prev.concat(cur)
              })
              : []
          }
          const item = {
            content,
            children: liability
          }
          accumulate.push(item)
          return accumulate
        }, [])
      }
      // 获取保障责任(desc1)
      function getLiabilitiesComponents (liability, insuranceData) {
        if (!liability || !insuranceData) return
        const productLiability = liability.insuranceLiabilities
        const productId = liability.productId
        function buildInsuranceInfo (insuranceLiability) {
          if (!Array.isArray(insuranceLiability.liabilities)) return
          return insuranceLiability.liabilities
            .map(item => {
              if (!item.description1) return
              const parsedDesc1Cfg = {
                productId,
                temp: item.description1,
                data: insuranceData
              }
              return {
                content: tempToFill(parsedDesc1Cfg, formatDisplayData)
              }
            })
            .filter(item => item && item.content)
        }
        return productLiability.map(item => {
          return buildInsuranceInfo(item)
        })
      }

      const insuredInfo = getAPerson('insuredInfo')
      const sexText = sexToString(insuredInfo.sex)
      const totalBaof = formatTenThousand(resultData.totalBaof)
      const prodOrderList = resultData.productGroupList[0].prodOrderList
      const calData = formatCalculateData(resultData, normalizeKeys).calData

      const map = {
        content: `${sexText}性 ${
          insuredInfo.age
        }岁<br>首年总保费<br>${totalBaof}元`,
        children: buildMapInfo(prodOrderList, liabilities, calData)
      }
      // 单个产品缩减层级
      if (liabilities.length === 1) {
        map.content = `${sexText}性 ${insuredInfo.age}岁<br>${
          map.children[0].content
        }`
        map.children = map.children[0].children
      }
      return map
    },
    buildMindFmData (memberList) {
      const vm = this
      function getMemberInfo (members, key) {
        let searchKey = 'key'
        if (typeof key === 'number') searchKey = 'id'
        return members.find(item => item[searchKey] === key)
      }
      function getMemberPlanbookData (planbookList, memberList) {
        if (!Array.isArray(planbookList)) return []
        return planbookList.reduce((acc, cur) => {
          const mindPbData = vm.buildMindPbData(cur)
          const planbookData = (mindPbData && mindPbData.children) || []
          return acc.concat(planbookData)
        }, [])
      }
      function getTotalBaof (dataList) {
        return dataList.reduce((previous, current) => {
          previous += parseFloat(current.baof)
          return previous
        }, 0)
      }
      if (!Array.isArray(memberList)) {
        return
      }
      const normalizedData = memberList.reduce((accumulate, current, index) => {
        if (!Array.isArray(current.insurances)) return accumulate
        const list = getMemberPlanbookData(current.insurances, memberList)
        const totalBaof = getTotalBaof(current.insurances)

        // 被保人
        const insured = {
          name: current.name || getRelation(current.type, current.sex),
          sexDesc: sexToString(current.sex),
          ageDesc: `${current.age}岁`
        }
        let contentText = `${insured.name} ${insured.sexDesc}${insured.ageDesc}`

        // 投保人
        const mainResultData = current.insurances && current.insurances[0]
        const activeMemberId = mainResultData && mainResultData.activeMemberId
        let applicantInfo
        if (activeMemberId) {
          applicantInfo = getMemberInfo(memberList, activeMemberId)
        } else if (mainResultData) {
          applicantInfo = getMemberInfo(
            mainResultData.resultData.personData.personOrderList,
            'applicantInfo'
          )
        }

        if (applicantInfo) {
          const applicant = {
            name:
              applicantInfo.name ||
              getRelation(applicantInfo.type, applicantInfo.sex),
            sexDesc: sexToString(applicantInfo.sex),
            ageDesc: `${applicantInfo.age}岁`
          }
          contentText += `<br>投保人：${applicant.name}<br>${
            applicant.sexDesc
          }${applicant.ageDesc}<br>首年总保费<br>${totalBaof}`
        }

        const memberData = {
          content: contentText,
          children: list,
          totalBaof
        }
        return accumulate.concat(memberData)
      }, [])

      return normalizedData
    },
    renderMind () {
      const vm = this
      const { mapData, screenSize } = this
      const maxProductNum = 10
      const multiProduct =
        Array.isArray(mapData.children) &&
        mapData.children[0] &&
        mapData.children[0].children
      // 多产品时限制最多显示10个产品
      const tree = multiProduct
        ? {
          children: mapData.children.slice(0, maxProductNum),
          content: mapData.content
        }
        : mapData

      const width = (this.viewWidth = Math.min(screenSize.width, 480) * 0.952)
      const height = (this.viewHeight = 400 - 34)
      const duration = 0
      const columnWidth = 200
      const mainColor = '#ff9e9e'
      const rectStrokeWidth = '3px'
      const rectRadius = 20
      const linkStrokeWidth = '3px'
      // 分组根节点id
      this.groupDepthId = []

      const engine = d3.layout.tree().setNodeSizes(true)

      // sizing
      engine.nodeSize(function (t) {
        return [t.x_size, t.y_size]
      })

      // gap
      engine.spacing(function (a, b) {
        return a.parent == b.parent ? 5 : engine.rootXSize()
      })

      // set the original coordinates of the root node
      tree.x0 = height / 2
      tree.y0 = 0

      // function to collapse data
      // 暂储子节点
      function collapse (d) {
        if (d.children) {
          d._children = d.children
          d._children.forEach(collapse)
          d.children = null
        }
      }

      // function for zoom
      // function redraw() {
      //   svg_g.attr(
      //     'transform',
      //     'translate(' +
      //       d3.event.translate +
      //       ')' +
      //       ' scale(' +
      //       d3.event.scale +
      //       ')'
      //   )
      // }

      // 显示隐藏子节点
      // function click(d) {
      //   if (d.children) {
      //     d3.select(this)
      //       .select('.vertical-line')
      //       .style('display', 'block')
      //     d._children = d.children
      //     d.children = null
      //   } else {
      //     d3.select(this)
      //       .select('.vertical-line')
      //       .style('display', 'none')
      //     d.children = d._children
      //     d._children = null
      //   }
      //   update(d)
      // }

      function update (source, callback) {
        // get nodes array
        let nodes = d3.layout.hierarchy()(tree)
        let last_id = 0
        // 设置每个 node id
        const node = svg_g.selectAll('.node').data(nodes, function (d) {
          const id = d.id || (d.id = ++last_id)
          // 记录组根节点
          if (d.depth === 1) {
            vm.groupDepthId.push(id)
          }
          return id
        })

        // append g and tansform to correct position
        const nodeEnter = node
          .enter()
          .append('g')
          .attr('class', 'node')
          .attr('transform', function () {
            const x_size = source.x_size ? source.x_size : 0
            return (
              'translate(' + source.y0 + ',' + (source.x0 - x_size / 2) + ')'
            )
          })
        // .on("click", click)

        // add text
        nodeEnter
          .append('text')
          .attr({
            id: function (d) {
              return d.id
            },
            dy: '0.35em',
            y: function (d) {
              return d.children || d._children ? '0.3em' : '0.5em'
            }
            // 'style': 'font: 10px sans-serif; stroke: transparent; pointer-events: none;'
          })
          .style('font-size', '1em')
          .each(function (d) {
            vm.parseText(this, d)
          })
        // compute node size
        engine.nodeSize(function (d) {
          const ele = document.getElementById(d.id)
          const ele_size = ele.getBBox()
          return [ele_size['height'] + 30, ele_size['width'] + 14]
        })

        // do the layout
        nodes = engine.nodes(tree)

        // get the extents, average node area, etc.
        function node_extents (n) {
          return [n.x - n.x_size / 2, n.y, n.x + n.x_size / 2, n.y + n.y_size]
        }

        const root_extents = node_extents(nodes[0])
        let xmin = root_extents[0]
        let ymin = root_extents[1]
        let xmax = root_extents[2]
        let ymax = root_extents[3]
        let area_sum = (xmax - xmin) * (ymax - ymin)
        let x_size_min = nodes[0].x_size
        let y_size_min = nodes[0].y_size

        nodes.slice(1).forEach(function (n) {
          const ne = node_extents(n)
          xmin = Math.min(xmin, ne[0])
          ymin = Math.min(ymin, ne[1])
          xmax = Math.max(xmax, ne[2])
          ymax = Math.max(ymax, ne[3])
          area_sum += (ne[2] - ne[0]) * (ne[3] - ne[1])
          x_size_min = Math.min(x_size_min, n.x_size)
          y_size_min = Math.min(y_size_min, n.y_size)
        })
        const scale = 1

        // functions to get the svg coordinates
        // 获取坐标
        function svg_x (node_y) {
          return (node_y - ymin) * scale
        }
        function svg_y (node_x) {
          return (node_x - xmin) * scale
        }

        // 提前获取将设定的坐标
        nodes.forEach(function (d) {
          const defaultY = d.depth * columnWidth
          d._x0 = svg_y(d.x)
          // d.y -> d.depth * columnWidth
          // fix 第一次设置时，未按列宽布局，故 y 为布局前的坐标值
          // 直接用 深度 * 固定w 代入计算
          d._y0 = svg_x(defaultY)
          // d.y0 = svg_x(d.y) d.y + 100 > defaultY ? d.y :
          // console.log('d', d)
        })

        // compute the distance according to the node size
        const nodebox_right_margin = Math.min(x_size_min * scale, 10)
        const nodebox_vertical_margin = Math.min(y_size_min * scale, 3)

        const filler = function (colorStr) {
          return (
            'fill-opacity: 0; stroke:' +
            colorStr +
            ';stroke-width: ' +
            rectStrokeWidth
          )
        }

        // reposition everything according to the layout
        // 根据布局定位所有内容
        node
          .transition()
          .duration(duration)
          .attr('transform', function (d) {
            const defaultVal = d.depth * columnWidth
            let step = 100 // 间距
            // 常规长度 columnWidth 每列
            // 若父节点宽度 > columnWidth 则设置当前节点位置 父节点宽度 + 100
            if (d.parent && d.parent._y0 && d.parent.y_size) {
              // 间距 < 1/2 时添加 1/2 间距
              if (
                Math.abs(defaultVal - (d.parent._y0 + d.parent.y_size + step)) <
                step / 2
              ) {
                step = step + step / 2
              }
              d.y = d.parent._y0 + d.parent.y_size + step
            } else {
              d.y = defaultVal
            }
            const offsetY = d.x_size * scale - nodebox_vertical_margin
            const pointY =
              d.children || d._children
                ? svg_y(d.x) - offsetY / 2
                : svg_y(d.x) - offsetY
            return 'translate(' + svg_x(d.y) + ',' + pointY + ')'
          })
        nodeEnter
          .filter(function (d) {
            return d.children || d._children
          })
          .append('rect')
          .attr({
            x: 0,
            rx: rectRadius,
            ry: rectRadius,
            width: function (d) {
              return d.y_size * scale - nodebox_right_margin
            },
            height: function (d) {
              return d.x_size * scale - nodebox_vertical_margin - 4
            },
            style: function (d) {
              if (!d.depth) return (d.filler = filler(mainColor))
              const color = vm.getGroupColor(d)
              return (d.filler = filler(color))
            }
          })
          .attr('next', function (d) {
            return !!(d.children || d._children)
          })
        nodeEnter
          .filter(function (d) {
            return !(d.children || d._children)
          })
          .append('line')
          .attr({
            x1: 0,
            x2: function (d) {
              return d.y_size * scale - nodebox_right_margin
            },
            y1: function (d) {
              return d.x_size * scale - nodebox_vertical_margin
            },
            y2: function (d) {
              return d.x_size * scale - nodebox_vertical_margin
            },
            style: function (d) {
              if (!d.depth) return (d.filler = filler(mainColor))
              if (
                vm.groupDepthId.length === tree.children.length &&
                !tree.children[0].children
              ) {
                return (d.filler = filler(groupColor[0]))
              }
              const color = vm.getGroupColor(d)
              return (d.filler = filler(color))
            }
          })
          .attr('next', function (d) {
            return !!(d.children || d._children)
          })

        node
          .exit()
          .transition()
          .duration(duration)
          .attr('transform', function (d) {
            return (
              'translate(' +
              source.y +
              ',' +
              (svg_y(source.x) -
                (source.x_size * scale - nodebox_vertical_margin) / 2) +
              ')'
            )
          })
          .remove()

        // control the lines between the nodes
        const diagonal = d3.svg
          .diagonal()
          .source(function (d) {
            const s = d.source
            return {
              x: s.x,
              y: s.y + s.y_size - nodebox_right_margin / scale
            }
          })
          .projection(function (d) {
            return [svg_x(d.y), svg_y(d.x)]
          })

        const enter_diagonal = d3.svg
          .diagonal()
          .source(function (d) {
            const s = d.source
            return {
              x: s.x,
              y: s.y + s.y_size - nodebox_right_margin / scale
            }
          })
          .projection(function (d) {
            return [d.y, d.x]
          })

        const links = engine.links(nodes)
        const link = svg_g.selectAll('path.link').data(links, function (d) {
          return d.target.id
        })

        link
          .enter()
          .insert('path', 'g')
          .attr('class', 'link')
          .attr('d', function (d) {
            const o = {
              x: source.x0,
              y: source.y0,
              y_size: source.y_size
            }
            return enter_diagonal({
              source: o,
              target: o
            })
          })
          .style('stroke', function (d) {
            if (
              vm.groupDepthId.length === tree.children.length &&
              !tree.children[0].children
            ) {
              return groupColor[0]
            }
            return vm.getGroupColor(d.target)
          })
          .style('stroke-width', linkStrokeWidth)
          .style('fill', 'none')

        // transition links to their new position.
        link
          .transition()
          .duration(duration)
          .attr('d', diagonal)

        // transition exiting nodes to the parent's new position
        link
          .exit()
          .transition()
          .duration(duration)
          .attr('d', function (d) {
            const o = {
              x: source.x,
              y: source.y,
              y_size: source.y_size
            }
            return diagonal({
              source: o,
              target: o
            })
          })
          .remove()

        // 保存坐标
        nodes.forEach(function (d) {
          d.x0 = d._x0
          d.y0 = d._y0
        })

        callback && callback()
      }

      const svg = d3
        .select('#mindMapping')
        .append('svg')
        .attr('width', width)
        .attr('height', height)

      const svg_g = svg.append('g')

      update(tree, function () {
        const zoom = 0.9
        let scale = 1
        let startX = 0
        let startY = 0
        setTimeout(() => {
          const size = (vm.size = svg_g[0][0].getBBox())
          // 长 > 宽
          if (size.height > size.width) {
            if (size.height > height) {
              scale = (height / size.height) * zoom
            }
          } else {
            if (size.width > width) {
              scale = (width / size.width) * zoom
            }
          }
          startX = (width - size.width * scale) / 2
          startY = (height - size.height * scale) / 2
          svg_g.attr(
            'transform',
            `translate(${startX}, ${startY}) scale(${scale})`
          )

          // add zoom event
          // svg.call(
          //   d3.behavior.zoom()
          //     .translate([startX, startY])
          //     .scale(scale)
          //     .scaleExtent([0.1, 1])
          //     .on('zoom', redraw)
          // )
          vm.svg = svg
          vm.loading = false
          appBridge.hideLoading()
        }, 800)
      })
    },
    /**
     * 获取分组颜色
     */
    getGroupColor (node) {
      const { groupDepthId } = this
      while (node && node.parent && node.parent.depth >= 1) {
        node = node.parent
      }
      const color = groupColor[groupDepthId.indexOf(node.id)]
      return color || '#eee'
    },
    /**
     * 格式转换
     * <br>|</br>换行
     * highlight 高亮数值
     */
    parseText (textTag, d) {
      const $text = d3.select(textTag)
      const content = d.content
      const spanFormt = { x: '2', dy: '1.5em' }
      if (typeof content !== 'string') return
      const newlineAry = content.split(/<\/br>|<br>|<br\/>/g)
      newlineAry.forEach(val => {
        const highlightReg = /(<span>(?:\d+|\d+[百千万亿元]+)<\/span>)/g
        const highlightMatch = /<span>((?:\d+|\d+)[百千万亿元]+)<\/span>/
        const startMatch = /<span>/g
        const endMatch = /<\/span>/g
        const highlightAry = val.split(highlightReg)
        if (highlightAry.length > 1) {
          highlightAry.forEach((tp, index) => {
            if (!tp) return
            const matchAry = tp.match(highlightMatch)
            if (matchAry && matchAry[1]) {
              tp = tp.replace(highlightReg, matchAry[1])
            }
            tp = tp.replace(startMatch, '').replace(endMatch, '')
            if (!index) {
              $text
                .append('tspan')
                .attr(spanFormt)
                .attr('fill', '#333333')
                .style('font-size', '1em')
                .text(tp)
              return
            }
            $text
              .append('tspan')
              .attr('fill', '#e58800')
              .attr('fontWeight', '500')
              .style('font-size', '1em')
              .text(tp)
          })
          return
        }
        val = val.replace(startMatch, '').replace(endMatch, '')
        $text
          .append('tspan')
          .attr(spanFormt)
          .attr('fill', '#333333')
          .style('font-size', '1em')
          .text(val)
      })
    },
    async handleExport (view) {
      try {
        let dataURL = this.dataURL
        if (!dataURL) {
          const svgString = this.getSVGString(this.svg.node())
          dataURL = await this.svgString2Image(svgString)
          this.dataURL = dataURL
        }
        if (!dataURL) return
        if (view) {
          showImageViewer(dataURL)
          return
        }
        this.$emit('export', dataURL)
      } catch (er) {
        console.log('er', er)
      }
    },
    svgString2Image (svgString) {
      function cuttingImage (content, width, height) {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = width
        canvas.height = height
        ctx.putImageData(content, 0, 0)
        return canvas.toDataURL()
      }
      const { size, viewWidth, viewHeight } = this
      const ishorizontal = size.width > size.height
      const ratio = ishorizontal
        ? size.width / viewWidth
        : size.height / viewHeight
      const width = viewWidth * ratio
      const height = viewHeight * ratio
      const sx = ishorizontal ? 0 : (width - size.width) / 2
      const sy = ishorizontal ? (height - size.height) / 2 : 0
      const sWidth = ishorizontal ? width : size.width
      const sHeight = ishorizontal ? size.height : height

      const imgsrc = `data:image/svg+xml;base64,${Base64.encode(svgString)}`
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = width
      canvas.height = height

      const image = new Image()
      return new Promise(resolve => {
        image.onload = () => {
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, width, height)
          ctx.drawImage(image, 0, 0, width, height)
          // 裁切
          const cutImage = ctx.getImageData(sx, sy, sx + sWidth, sy + sHeight)
          resolve(cuttingImage(cutImage, sWidth, sHeight))
        }
        image.onerror = () => {
          // 加载异常
          resolve(null)
        }
        image.src = imgsrc
      })
    },
    getSVGString (svgNode) {
      svgNode.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')
      const serializer = new XMLSerializer()
      let svgString = serializer.serializeToString(svgNode)
      svgString = svgString.replace(/NS\d+:href/g, 'xlink:href')
      return svgString
    }
  }
}
</script>
<template>
  <div
    id="mindMapping"
    class="chart-wrapper"
    :class="{ loading: loading }"
    @click="handleExport(true)"
  />
</template>
<style scoped>
.loading {
  visibility: hidden;
}
</style>
